import * as React from "react";
import { RefObject } from "react";

export default function SafeHtmlContent({
  unsafeHtml,
  fontsUrl,
}: {
  unsafeHtml: String;
  fontsUrl: String;
}) {
  const iframeRef: RefObject<HTMLIFrameElement> = React.createRef<HTMLIFrameElement>();
  const resizeIframe = () => {
    iframeRef.current.style.height =
      iframeRef.current.contentWindow.document.body.scrollHeight + 1 + "px";
    if (window["verticalDropdownUtil"]) {
      window["verticalDropdownUtil"].triggerResize(document.body);
    }
  };

  const woff2 = `${fontsUrl}/SourceSansPro-Light.ttf.woff2`;
  const woff = `${fontsUrl}/SourceSansPro-Light.otf.woff`;
  const otf = `${fontsUrl}/SourceSansPro-Light.otf`;
  const ttf = `${fontsUrl}/SourceSansPro-Light.ttf`;

  return (
    <iframe
      ref={iframeRef}
      srcDoc={`
                  <style>
                    @font-face {
                      font-family: "Source Sans Pro";
                      font-weight: 300;
                      font-style: normal;
                      font-stretch: normal;
                      font-display: swap;
                      src: url(${woff2}) format("woff2"),
                           url(${woff}) format("woff"),
                           url(${otf}) format("opentype"),
                           url(${ttf}) format("truetype");
                    }
                    body { 
                      margin: 0; 
                      font-size: 1rem;
                      font-weight: 300;
                      font-family: 'Source Sans Pro', sans-serif;
                     }
                    body > :first-child { margin-top: 0; }
                    body > :last-child { margin-bottom: 0; }
                    p:first-of-type { margin-top: 0; }
                  </style>
                  ${unsafeHtml}`}
      sandbox={"allow-same-origin"}
      style={{ width: "100%", height: 0 }}
      onLoad={resizeIframe}
    ></iframe>
  );
}
